module.exports = __webpack_public_path__ + "static/media/Backwardarrow.0b3af68d.svg";